<template>
  <div class="login-page">
    <div class="login-grid-bg"></div>
    <div class="login-shell">
      <section class="login-showcase">
        <div class="showcase-mark">
          <img src="@/assets/logo/1024.png" alt="heliumflash-tools">
        </div>
        <p class="showcase-kicker">PRIVATE WORKBENCH</p>
        <h1 class="typewriter">heliumflash-tools</h1>
<!--        <p class="showcase-copy">lightweight tools, clean data, fast delivery.</p>-->

        <div class="signal-panel glass-panel" aria-hidden="true">
          <div class="signal-toolbar">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="signal-lines">
            <i></i>
            <i></i>
            <i></i>
          </div>
          <div class="signal-status">
            <span>AUTH</span>
            <strong>READY</strong>
          </div>
        </div>
      </section>

      <section class="login-card glass-panel">
        <div class="login-brand">
<!--          <div class="brand-mark">-->
<!--            <img src="@/assets/logo/1024.png" alt="heliumflash-tools">-->
<!--          </div>-->
          <div>
<!--            <p>HeliumFlash Tools</p>-->
            <h2>暗号验证</h2>
          </div>
        </div>

        <form class="login-form" @submit.prevent="goLogin">
          <label class="login-field">
            <span>用户名</span>
            <input
              class="hf-field login-input"
              v-model.trim="form.target"
              placeholder="username"
              autocomplete="username"
            >
          </label>
          <label class="login-field">
            <span>密码</span>
            <input
              class="hf-field login-input"
              v-model="form.pwd"
              type="password"
              placeholder="password"
              autocomplete="current-password"
            >
          </label>
          <button
            class="hf-btn hf-btn--primary login-submit"
            type="submit"
            :disabled="loading"
          >
            {{ loading ? '验证中' : '进入控制台' }}
          </button>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import {doLogin} from "@/api/login";
import {getFirstMenuRoute} from "@/utils/menu";

export default {
  name: 'LoginUser',
  data() {
    return {
      loading: false,
      form: {
        target: '',
        pwd: ''
      }
    };
  },
  methods: {
    goLogin() {
      if (!this.form.target || !this.form.pwd) {
        this.$message.warning('先把暗号填完整');
        return;
      }

      this.loading = true;
      doLogin(this.form.target, this.form.pwd).then(res => {
        if (res && res.data && res.data.token) {
          const userInfo = {
            id: res.data.id,
            userName: res.data.userName,
            phoneMark: res.data.phoneMark
          };
          window.localStorage.setItem("oauthToken", res.data.token);
          window.sessionStorage.setItem("loginToken", res.data.token);
          window.localStorage.setItem("menuList", JSON.stringify(res.data.menuList || []));
          window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
          this.$router.replace(getFirstMenuRoute(res.data.menuList || []));
        } else {
          this.$notify({
            title: '登录失败',
            message: '用户名或密码错误',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$notify({
          title: '登录失败',
          message: '服务暂时没有回应',
          type: 'error'
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 36px;
}

.login-page::before {
  position: absolute;
  inset: 0;
  content: "";
  background:
    radial-gradient(circle at 18% 22%, rgba(216, 236, 255, .9), transparent 28%),
    radial-gradient(circle at 78% 16%, rgba(236, 230, 255, .76), transparent 24%),
    linear-gradient(135deg, rgba(255, 255, 255, .92), rgba(241, 247, 252, .86));
}

.login-page::after {
  position: absolute;
  inset: 0;
  content: "";
  background: linear-gradient(115deg, transparent 0%, rgba(255, 255, 255, .42) 44%, transparent 58%);
  animation: page-sheen 7s ease-in-out infinite;
  pointer-events: none;
}

.login-grid-bg {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(rgba(15, 23, 42, .04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 23, 42, .04) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: linear-gradient(115deg, rgba(0, 0, 0, .76), transparent 72%);
}

.login-shell {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(420px, 1fr) minmax(360px, 440px);
  align-items: center;
  width: min(1180px, 100%);
  min-height: calc(100vh - 72px);
  margin: 0 auto;
  gap: 72px;
}

.login-showcase {
  position: relative;
  min-width: 0;
  padding-left: 10px;
}

.login-showcase::before,
.login-showcase::after {
  position: absolute;
  content: "";
  border: 1px solid rgba(15, 23, 42, .08);
  pointer-events: none;
}

.login-showcase::before {
  top: -44px;
  left: -26px;
  width: 190px;
  height: 190px;
  border-right-color: transparent;
  border-bottom-color: transparent;
  animation: corner-drift 5s ease-in-out infinite;
}

.login-showcase::after {
  right: 12%;
  bottom: -60px;
  width: 120px;
  height: 120px;
  border-left-color: transparent;
  border-top-color: transparent;
  animation: corner-drift 5s ease-in-out infinite reverse;
}

.showcase-mark {
  display: grid;
  width: 58px;
  height: 58px;
  place-items: center;
  border-radius: 18px;
  background: rgba(255, 255, 255, .42);
  box-shadow: 0 18px 42px rgba(15, 23, 42, .08);
  color: #101828;
  font-size: 26px;
  font-weight: 900;
  backdrop-filter: blur(18px);
  overflow: hidden;
}

.showcase-mark img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.showcase-kicker {
  margin: 42px 0 12px;
  color: #667085;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .16em;
}

.typewriter {
  width: 18ch;
  max-width: 100%;
  overflow: hidden;
  border-right: 3px solid #101828;
  color: #101828;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
  font-size: 64px;
  font-weight: 900;
  line-height: 1.02;
  margin: 0;
  white-space: nowrap;
  animation: typing 2.5s steps(18, end), caret .82s step-end infinite;
}

.showcase-copy {
  max-width: 560px;
  margin: 24px 0 0;
  color: #475467;
  font-size: 17px;
  line-height: 1.8;
}

.signal-panel {
  position: relative;
  width: min(420px, 88%);
  margin-top: 48px;
  overflow: hidden;
  border-radius: 22px;
  padding: 18px;
}

.signal-panel::after {
  position: absolute;
  inset: 0;
  content: "";
  background: linear-gradient(90deg, transparent, rgba(16, 24, 40, .08), transparent);
  transform: translateX(-100%);
  animation: signal-scan 3.8s ease-in-out infinite;
}

.signal-toolbar {
  display: flex;
  gap: 7px;
}

.signal-toolbar span {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #101828;
  opacity: .72;
}

.signal-lines {
  display: grid;
  gap: 10px;
  margin: 24px 0;
}

.signal-lines i {
  display: block;
  height: 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, #101828, rgba(16, 24, 40, .08));
  animation: line-pulse 2.4s ease-in-out infinite;
}

.signal-lines i:nth-child(1) {
  width: 78%;
}

.signal-lines i:nth-child(2) {
  width: 54%;
  animation-delay: .18s;
}

.signal-lines i:nth-child(3) {
  width: 68%;
  animation-delay: .36s;
}

.signal-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .12em;
}

.signal-status strong {
  color: #101828;
}

.login-card {
  position: relative;
  justify-self: end;
  width: min(440px, 100%);
  border-radius: 24px;
  padding: 36px;
  background: rgba(255, 255, 255, .78);
}

.login-card::before {
  position: absolute;
  inset: 10px;
  border: 1px solid rgba(15, 23, 42, .05);
  border-radius: 18px;
  content: "";
  pointer-events: none;
}

.login-brand {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 30px;
}

.brand-mark {
  display: grid;
  width: 50px;
  height: 50px;
  place-items: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, .42);
  color: #101828;
  font-size: 22px;
  font-weight: 900;
  overflow: hidden;
}

.brand-mark img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-brand p {
  margin: 0 0 5px;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .12em;
  text-transform: uppercase;
}

.login-brand h2 {
  margin: 0;
  color: #101828;
  font-size: 28px;
}

.login-form {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #475467;
  font-size: 13px;
  font-weight: 800;
}

.login-input {
  height: 46px;
}

.login-submit {
  width: 100%;
  height: 46px;
  margin-top: 4px;
  font-weight: 800;
}

@keyframes typing {
  from {
    width: 0;
  }
}

@keyframes caret {
  50% {
    border-color: transparent;
  }
}

@keyframes signal-scan {
  50%,
  100% {
    transform: translateX(100%);
  }
}

@keyframes line-pulse {
  50% {
    opacity: .48;
    transform: scaleX(.88);
    transform-origin: left;
  }
}

@keyframes corner-drift {
  50% {
    transform: translate(10px, -8px);
  }
}

@keyframes page-sheen {
  0%,
  55% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

@media (max-width: 920px) {
  .login-page {
    padding: 22px;
  }

  .login-shell {
    grid-template-columns: 1fr;
    gap: 28px;
    min-height: calc(100vh - 44px);
  }

  .login-showcase {
    padding-left: 0;
  }

  .showcase-kicker {
    margin-top: 28px;
  }

  .typewriter {
    font-size: 34px;
  }

  .signal-panel {
    width: 100%;
    margin-top: 26px;
  }

  .login-card {
    justify-self: stretch;
    padding: 28px;
  }
}

@media (max-width: 420px) {
  .typewriter {
    font-size: 30px;
  }
}
</style>
